import React from 'react'
import { Flex, Image, Link, Text } from 'theme-ui'
import GonationLogo from './Icons/PoweredByGoNation'

export default function GonationLogoPowered() {
  return (
    <Flex className="gonationLogo" sx={styles.container}>
      <Link href="https://www.gonation.com" target="_blank" rel="noreferrer" sx={styles.link}>
        <GonationLogo />
      </Link>
    </Flex>
  )
}

const styles = {
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    width: '100%',
    svg: {
      width: 'fit-content',
      maxWidth: '200px',
      width: '200px'
    }
  },
  link: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}
